import { StartExercise, UpdateObjective } from "Phaser/EventBus";
import { Exercise, Lecture, Tutorial, Section, Event, StaffExercise, NoteSequenceExercise } from "Utils/TutorialConfigHelper";
import { AddEventsAndMergeTimestamps, Timestamps } from "Utils/ChaptersToTimestamps";
import timestamps from "./level15.json";

const Level15 = Tutorial(15,
  '4:32',
  [
    Section([
      Lecture('Silence in Music', '0:0'),
      Lecture('Rest Symbols', '0:26'),
      Lecture('Quarter Rests', '0:46'),
      Exercise('Quarter Rests', '1:01',
        NoteSequenceExercise({
          tempo: 60,
          objectives: [
            {
              text: "Use any key to play this rhythm in time with the metronome.",
              videoSkipDestination: '1:20',
              notes: [
                { length: 'quarter' },
                { length: 'quarter', isRest: true },
                { length: 'quarter' },
                { length: 'quarter', isRest: true },
                { length: 'quarter' },
                { length: 'quarter', isRest: true },
                { length: 'quarter', isRest: true },
                { length: 'quarter' },
              ]
            },
            {
              text: "Use any key to play this rhythm in time with the metronome.",
              notes: [
                { length: 'quarter' },
                { length: 'quarter' },
                { length: 'quarter', isRest: true },
                { length: 'quarter' },
                { length: 'half' },
                { length: 'quarter', isRest: true },
                { length: 'quarter' },
              ]
            }
          ]
        }),
        [
        ]
      ),
      Lecture('Half Rests', '1:35'),
      Exercise('Half Rests', '1:48',
        NoteSequenceExercise({
          tempo: 60,
          objectives: [
            {
              scale: 1.2,
              text: "Use any key to play this rhythm in time with the metronome.",
              notes: [
                { length: 'half' },
                { length: 'half', isRest: true },
                { length: 'quarter' },
                { length: 'half', isRest: true },
                { length: 'quarter' },
              ]
            },
            {
              text: "Use any key to play this rhythm in time with the metronome.",
              notes: [
                { length: 'quarter' },
                { length: 'half', isRest: true },
                { length: 'quarter' },
                { length: 'half', isRest: true },
                { length: 'half' },
              ]
            }
          ]
        }),
        [
        ]
      ),
      Lecture('Whole Rests', '2:14'),
      Exercise('Whole Rests', '2:37',
        NoteSequenceExercise({
          tempo: 60,
          objectives: [
            {
              scale: 0.6,
              text: "Use any key to play this rhythm in time with the metronome.",
              notes: [
                { length: 'whole' },
                { length: 'whole', isRest: true },
                { length: 'quarter' },
                { length: 'quarter' },
                { length: 'whole', isRest: true },
                { length: 'half' },
              ]
            },
          ]
        }),
        [
        ]
      ),
      Exercise('Combining Rests', '2:58',
        NoteSequenceExercise({
          tempo: 60,
          transitionDelay: 0,
          objectives: [
            {
              scale: 0.6,
              text: "Use any key to play this rhythm in time with the metronome.",
              notes: [
                { length: 'half' },
                { length: 'quarter', isRest: true },
                { length: 'quarter' },
                { length: 'half', isRest: true },
                { length: 'quarter' },
                { length: 'quarter' },
                { length: 'whole', isRest: true },
                { length: 'quarter' },
                { length: 'quarter' },
                { length: 'quarter', isRest: true },
                { length: 'quarter' },
              ]
            },
          ]
        }),
        [
        ]
      ),
    ]),
    Section([
      Lecture('Rests on the Staff', '3:19'),
      Exercise('Rests on the Staff', '3:49',
        StaffExercise({
          objectives: [
            {
            },
            {
            },
          ]
        }),
        [
        ]
      ),
      Lecture('Playing Rests in Both Hands', '4:03'),
      Exercise('Hands Together', '4:20',
        StaffExercise({
          objectives: [
            {
            },
            {
            },
          ]
        }),
        [
        ]
      )
    ]),
  ]
);

export default AddEventsAndMergeTimestamps(timestamps as Timestamps, Level15);
